import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import classnames from 'classnames';
import { FileUrl, FileDownloadUrl } from '../../utils/api/services/files';
import ContentModal from '../../components/Modals/ContentModal';
import constants from '../../utils/constants';

export default class ForumAttachedFile extends Component {
  static propTypes = {
    attach: PropTypes.shape({
      extension: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
    }),
    type: PropTypes.string,
    vimeoLink: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.state = {
      showContentModal: false,
    };
  }

  componentWillMount = () => {
    if (this.props.vimeoVideoId) {
      axios
        .get(`http://vimeo.com/api/v2/video/${this.props.vimeoVideoId}.json`)
        .then((response) => {
          const vimeoVideoPreview = response.data && response.data[0] && response.data[0].thumbnail_medium;
          const vimeoVideoName = response.data && response.data[0] && response.data[0].title;

          this.setState({
            vimeoVideoPreview,
            vimeoVideoName,
          });
        })
        .catch((e) => {
          console.log('не удалось получить информацию о видео');
          console.log(e);
        });
    }
  };

  getType = (extension) => {
    switch (extension) {
      case 'jpeg':
      case 'jpg':
      case 'png':
        return 'image';
        break;

      case 'ogg':
      case 'mp4':
        return 'video';
        break;

      default:
        return 'file';
        break;
    }
  };

  handleClick = (type) => {
    if (type === 'image' || type === 'video' || type === 'vimeoVideo') {
      this.setState({
        showContentModal: true,
      });
    } else {
      this.setState({
        showContentModal: false,
      });
    }
  };

  render() {
    const { attach, vimeoLink } = this.props;
    const { showContentModal, vimeoVideoName, vimeoVideoPreview } = this.state;
    const type = this.props.type || this.getType(attach.extension);

    const fileUrl = type === 'vimeoVideo' ? vimeoLink : FileUrl(attach.id);
    let fileUrlForPreview = '';
    switch (type) {
      case 'image':
        fileUrlForPreview = FileUrl(
          attach.id,
          constants.imageSize.attachedImageSizes.width,
          constants.imageSize.attachedImageSizes.height,
        );
        break;

      case 'vimeoVideo':
        fileUrlForPreview = vimeoVideoPreview;
        break;

      default:
        fileUrlForPreview = fileUrl;
        break;
    }
    const downloadUrl = attach && FileDownloadUrl(attach.id);
    const fileName = vimeoVideoName || (attach && attach.name);

    return (
      <React.Fragment>
        <div className="post-content__file" onClick={() => this.handleClick(type)}>
          {type === 'image' ? (
            <React.Fragment>
              <img className="post-content__file-preview" src={fileUrlForPreview} alt="" />
              <div className="post-content__file-caption">{attach.name}</div>
            </React.Fragment>
          ) : (
            ''
          )}
          {type === 'vimeoVideo' ? (
            <React.Fragment>
              <img
                className={classnames('post-content__file-preview', {
                  'post-content__file-preview--simple-icon': !fileUrlForPreview,
                })}
                src={fileUrlForPreview || '/Content/images/icons/play.svg'}
                width="40"
                height="40"
                alt=""
              />
              <div className="post-content__file-caption">{fileName}</div>
            </React.Fragment>
          ) : (
            ''
          )}
          {type === 'video' ? (
            <React.Fragment>
              <img
                className="post-content__file-preview post-content__file-preview--simple-icon"
                src="/Content/images/icons/play.svg"
                width="40"
                height="40"
                alt=""
              />
              <div className="post-content__file-caption">{attach.name}</div>
            </React.Fragment>
          ) : (
            ''
          )}
          {type === 'file' ? (
            <React.Fragment>
              <a href={downloadUrl}>
                <img
                  className="post-content__file-preview post-content__file-preview--simple-icon"
                  src="/Content/images/icons/document-icon.svg"
                  width="40"
                  height="40"
                  alt=""
                />
              </a>
              <a href={downloadUrl}>
                <div className="post-content__file-caption">{attach.name}</div>
              </a>
            </React.Fragment>
          ) : (
            ''
          )}
        </div>

        {showContentModal ? (
          <ContentModal
            visible={showContentModal}
            name={fileName}
            src={fileUrl}
            extension={attach && attach.extension}
            type={type}
            hide={() => {
              this.setState({ showContentModal: false });
            }}
          />
        ) : (
          ''
        )}
      </React.Fragment>
    );
  }
}
